import { ActionTypes } from '../../constants/ActionTypes';

export const onGetSecretariatList = (searchText: string | undefined) => {
  return {
    type: ActionTypes.GET_SECRETARIAT_LIST,
    payload: searchText,
  };
};

export const fetchSecretariatListSuccess = (secretariatList: any[]) => {
  return {
    type: ActionTypes.FETCH_SECRETARIAT_LIST_SUCCESS,
    payload: secretariatList,
  };
};
